import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import { retry } from "../common/utils/commonFunction";

const EditProfile = lazy(() =>
  retry(() => import("../pages/brand/EditProfile"))
);
const BrandDashboard = lazy(() =>
  retry(() => import("../pages/brand/Dashboard"))
);
const MyProduct = lazy(() => retry(() => import("../pages/brand/MyProduct")));
const AddProduct = lazy(() => retry(() => import("../pages/brand/AddProduct")));
const CreateJobForm = lazy(() =>
  retry(() => import("../pages/brand/CreateJobForm"))
);
const CreateJob = lazy(() => retry(() => import("../pages/brand/CreateJob")));
const SelectJob = lazy(() => retry(() => import("../pages/brand/SelectJob")));
const JobDetails = lazy(() => retry(() => import("../pages/brand/JobDetails")));
const CreatorDetails = lazy(() =>
  retry(() => import("../pages/brand/CreatorDetails"))
);
const CreatorProfile = lazy(() =>
  retry(() => import("../pages/brand/CreatorProfile"))
);
const TransactionHistory = lazy(() =>
  retry(() => import("../pages/brand/TransactionHistory"))
);

const brandRoutes = [
  {
    path: "/brand",
    element: <Navigate to="/creator/dashboard" replace />,
  },
  {
    path: "/brand/edit-profile",
    element: <EditProfile />,
  },
  {
    path: "/brand/dashboard",
    element: <BrandDashboard />,
  },
  {
    path: "/brand/add-product",
    element: <AddProduct />,
  },
  {
    path: "/brand/edit-product/:productId",
    element: <AddProduct />,
  },
  {
    path: "/brand/my-product",
    element: <MyProduct />,
  },
  {
    path: "/brand/create-job",
    element: <CreateJob />,
  },
  {
    path: "/brand/creator-profile",
    element: <CreatorProfile />,
  },
  {
    path: "/brand/select-job",
    element: <SelectJob />,
  },
  {
    path: "/brand/create-job/:productId",
    element: <CreateJobForm />,
  },
  {
    path: "/brand/edit-job/:jobId",
    element: <CreateJobForm />,
  },
  {
    path: "/brand/job/:jobId",
    element: <JobDetails />,
  },
  {
    path: "/brand/job/:jobId/creator-profile",
    element: <CreatorDetails />,
  },
  {
    path: "/brand/transaction-history",
    element: <TransactionHistory />,
  },
];

export default brandRoutes;
